import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  Col,
  Input,
  FormGroup,
  Button,
  ButtonGroup,
  Card,
  UncontrolledTooltip,
} from 'reactstrap';

class SocialMediaMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSocialMessage: false,
      message: '',
      error: '',
    };
  }

  componentDidMount() {
    const { message } = this.props;
    this.setState({ message });
  }

  componentDidUpdate(prevProps) {
    const { message } = this.props;

    if (prevProps.message !== message) {
      this.setState({ message });
    }
  }

  cancelUpdateMessage = () => {
    const { message } = this.props;

    this.setState({
      message,
      error: '',
    });
    this.toggleMessageInput();
  };

  updateMessage = () => {
    const { onCustomMessageChange } = this.props;
    const { message } = this.state;

    if (this.checkLength()) {
      this.setState({
        error: '',
      });
      this.toggleMessageInput();
      onCustomMessageChange(message.trim());
    }
  };

  onMessageChange = e => {
    this.setState(
      {
        message: e.target.value,
        error: '',
        isError: false,
      },
      this.checkLength
    );
  };

  checkLength = () => {
    const { message } = this.state;

    if (message.trim().length === 0) {
      this.setState({
        error: 'Message is required ',
        isError: true,
      });
      return false;
    } else if (message.length >= 300) {
      this.setState({
        error: "Message mustn't exceed 300 characters",
        isError: true,
      });
      return false;
    }

    return true;
  };

  updateInformation = () => {
    const { onCustomMessageChange } = this.props;
    const { message } = this.state;

    if (this.checkLength()) {
      onCustomMessageChange(message);
    }
  };

  toggleMessageInput() {
    this.setState(prevState => ({
      showSocialMessage: !prevState.showSocialMessage,
    }));
  }

  handleBlur = e => {
    const { value } = e.target;
    this.setState({ message: value.trim() });
  };

  render() {
    const { type } = this.props;
    const { showSocialMessage, error, message } = this.state;
    const addonTypeTitle = type === 'media_type' ? 'media' : 'review';

    return (
      <div className=" styled-box-shadow  row mb-1 bg-light">
        <div className="float-left w-100 p-3">
          <div className="float-left ml-3">
            <FontAwesomeIcon icon="comment-alt" />
            <span classname="font-weight-bold">
              Message for social {addonTypeTitle} add-ons
            </span>
          </div>
          {!showSocialMessage && (
            <span
              className="float-right cursor-pointer "
              onClick={() => this.toggleMessageInput()}
              id="socialMessage"
            >
              <FontAwesomeIcon icon="pencil-alt" />
              <UncontrolledTooltip
                placement="bottom"
                target="socialMessage"
                style={{ fontSize: '0.75em' }}
              >
                Edit message
              </UncontrolledTooltip>
            </span>
          )}

          <Col md={{ size: 16 }} className="addon-input pl-2 pr-3">
            <div className=" ml-2 ">
              <hr />
              <form autoComplete="off">
                {showSocialMessage ? (
                  <React.Fragment>
                    <FormGroup className="mb-3">
                      <Input
                        rows="3"
                        className="message-box"
                        placeholder="Write your custom message here..."
                        type="textarea"
                        onChange={this.onMessageChange}
                        onBlur={this.handleBlur}
                        value={message}
                        required
                      />
                    </FormGroup>
                    <ButtonGroup className="float-right">
                      <Button
                        className="btn-cancel"
                        onClick={() => this.cancelUpdateMessage()}
                      >
                        Cancel
                      </Button>
                      <Button
                        className=" font-weight-bold btn-success "
                        onClick={() => this.updateMessage()}
                      >
                        Update
                      </Button>
                    </ButtonGroup>
                  </React.Fragment>
                ) : (
                  <div className="reward p-2 mb-2">
                    <p>{message}</p>
                  </div>
                )}
                <div className="row error"> {error} </div>
              </form>
            </div>
          </Col>
        </div>
      </div>
    );
  }
}

SocialMediaMessage.propTypes = {
  message: PropTypes.string.isRequired,
  onCustomMessageChange: PropTypes.func.isRequired,
};

export default SocialMediaMessage;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/info-edit/social-media/SocialMediaMessage.js